"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const DonutProgress_vue_1 = __importDefault(require("./DonutProgress.vue"));
const NumberContentTrials_vue_1 = __importDefault(require("./NumberContentTrials.vue"));
const SeeCodesTrials_vue_1 = __importDefault(require("./SeeCodesTrials.vue"));
const lucide_vue_next_1 = require("lucide-vue-next");
const floating_vue_1 = require("floating-vue");
const ModalTrialsTracking_vue_1 = __importDefault(require("./ModalTrialsTracking.vue"));
const TrialsSampleState_1 = __importDefault(require("./utils/controllers/TrialsSampleState"));
let TrialsConfigCycleItem = class TrialsConfigCycleItem extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.contentDonut = 'numbers';
        this.isDeployModal = false;
        this.stateModal = '';
        this.codesSamplesCheckArray = [];
        this.deployModalResponseMarkSent = false;
        this.allStates = [
            {
                id: 1,
                name: 'Pending send',
                name_formatted: 'pending_send',
            },
            {
                id: 2,
                name: 'Pending lab but sent',
                name_formatted: 'pending_lab_but_sent',
            },
            {
                id: 3,
                name: 'At lab',
                name_formatted: 'at_lab',
            },
            {
                id: 4,
                name: 'Pending metadata',
                name_formatted: 'pending_metadata',
            },
            {
                id: 5,
                name: 'Analyzed',
                name_formatted: 'analyzed',
            },
            {
                id: 6,
                name: 'Finished',
                name_formatted: 'finished',
            },
        ];
        this.stateTrialsController = new TrialsSampleState_1.default(this.numberSamples, this.collectState, this.projectId);
    }
    loadConfigTrials() {
        window.location.href = `/tracking/project/configuration?proposal=${this.proposalId}&project=${this.projectId}`;
    }
    get loadingMark() {
        return this.stateTrialsController.loadingMark;
    }
    callProjectInfo() {
        this.$emit('callProjectInfo');
    }
    callSamples() {
        this.stateTrialsController.callAllSamples(this.projectId, this.collectState.name_formatted);
    }
    callSamplesPendding() {
        this.stateTrialsController.callAllSamples(this.projectId, 'pending_send');
    }
    callSamplesSubState() {
        this.stateTrialsController.callAllSamples(this.projectId, 'sent_at_lab');
    }
    dismissModalMarkSent(value) {
        this.deployModalResponseMarkSent = value;
    }
    get collectState() {
        for (const state of this.allStates) {
            if (state.name_formatted === this.stateName) {
                return state;
            }
        }
    }
    get collectAllSamples() {
        return this.stateTrialsController.getAllSamples();
    }
    get loadingSamples() {
        return this.stateTrialsController.getLoadingAllSamples();
    }
    get isDeployActionMarkSent() {
        return this.stateTrialsController.isDeployActionMarkSent();
    }
    get isDeploySubState() {
        return this.stateTrialsController.isDeploySubState();
    }
    get collectPercentage() {
        return (100 * this.numberSamples) / this.totalSamples;
    }
    deployModal(value) {
        this.isDeployModal = true;
        this.stateModal = value;
    }
    dismissModal() {
        this.isDeployModal = false;
    }
    codesSamplesCheck(codes) {
        this.deployModalResponseMarkSent = true;
        this.codesSamplesCheckArray = codes;
        this.stateTrialsController.markSamplesSent(codes, this.projectId);
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Number, default: 0 })
], TrialsConfigCycleItem.prototype, "numberSamplesSubState", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Number, default: 0 })
], TrialsConfigCycleItem.prototype, "numberSamples", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Number, default: 0 })
], TrialsConfigCycleItem.prototype, "projectId", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Number, default: 0 })
], TrialsConfigCycleItem.prototype, "proposalId", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Number, default: 0 })
], TrialsConfigCycleItem.prototype, "totalSamples", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '' })
], TrialsConfigCycleItem.prototype, "stateName", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: 'primary' })
], TrialsConfigCycleItem.prototype, "accent", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], TrialsConfigCycleItem.prototype, "activeDonut", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], TrialsConfigCycleItem.prototype, "activeSubState", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], TrialsConfigCycleItem.prototype, "loadingProjectInfo", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '' })
], TrialsConfigCycleItem.prototype, "globalTextSearch", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], TrialsConfigCycleItem.prototype, "configButton", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: true })
], TrialsConfigCycleItem.prototype, "configButtonActive", void 0);
TrialsConfigCycleItem = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            DonutProgress: DonutProgress_vue_1.default,
            NumberContentTrials: NumberContentTrials_vue_1.default,
            Button: bmk_ui_framework_1.Button,
            ShipmentIcon: bmk_ui_framework_1.ShipmentIcon,
            SeeCodesTrials: SeeCodesTrials_vue_1.default,
            X: lucide_vue_next_1.X,
            Info: lucide_vue_next_1.Info,
            Dropdown: floating_vue_1.Dropdown,
            ModalTrialsTracking: ModalTrialsTracking_vue_1.default,
            CheckAloneIcon: bmk_ui_framework_1.CheckAloneIcon,
            Modal: bmk_ui_framework_1.Modal,
            CheckRoundedIcon: bmk_ui_framework_1.CheckRoundedIcon,
            Loading: bmk_ui_framework_1.Loading,
            Loader: bmk_ui_framework_1.Loader,
            ArrowLeftIcon: bmk_ui_framework_1.ArrowLeftIcon,
        },
    })
], TrialsConfigCycleItem);
exports.default = TrialsConfigCycleItem;
